import { Controller, useFormContext, useFormState } from "react-hook-form";
import type { IFormFieldProps, IRadioProps } from "@/ui-kit";
import { FormField, Radio, RadioCard } from "@/ui-kit";
import { get } from "../utils";

export type IRadioControlProps = Omit<IRadioProps, "checked" | "onChange"> &
  Omit<
    IFormFieldProps,
    "label" | "description" | "htmlFor" | "tooltipContent" | "children"
  > & {
    name: string;
    formElementClass?: string;
    onChange?: (value: string) => void;
    variant?: "default" | "card";
  };

export const RadioControl = (props: IRadioControlProps) => {
  const {
    message,
    required,
    accessory,
    formElementClass,
    name,
    value,
    onChange,
    variant = "default",
    ...restRadioProps
  } = props;
  const { control } = useFormContext();
  const { errors } = useFormState();
  const errorMessage = get(errors, name)?.message as string | undefined;

  const radioElement = (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onFieldChange, value: fieldValue } }) => {
        const handleChange = (selectedValue: string) => {
          onFieldChange(selectedValue);

          if (onChange) {
            onChange(selectedValue);
          }
        };

        const isChecked = fieldValue === value;

        const Component = variant === "card" ? RadioCard : Radio;

        return (
          <Component
            {...restRadioProps}
            name={name}
            value={value}
            checked={isChecked}
            onChange={handleChange}
            isCard={variant === "card"}
          />
        );
      }}
    />
  );

  return (
    <FormField
      message={message ?? errorMessage}
      required={required}
      className={formElementClass}
      accessory={accessory}
    >
      {radioElement}
    </FormField>
  );
};
